import { motion } from "framer-motion";
import { ArrowUpRight, Instagram, Linkedin } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { BRAND, BRAND_SUB, CONTACT_EMAIL, NAV_LINKS, QUICK_LINKS, SOCIAL_LINKS } from "@/data/content";

const SOCIAL_ICONS = { instagram: Instagram, linkedin: Linkedin };

export const Contact = () => {
  return (
    <footer id="iletisim" className="relative bg-surface pt-28 md:pt-40 px-6 md:px-10 overflow-hidden">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-10">İletişim</p>
        </Reveal>

        <Reveal delay={1}>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="contact-headline" className="group block">
            <h2 className="font-semibold tracking-tight leading-[0.9] text-sand text-[15vw] md:text-[11vw] lg:text-[9rem]">
              İletişime geçin
            </h2>
          </a>
        </Reveal>

        <div className="mt-12 md:mt-20 grid grid-cols-1 md:grid-cols-12 gap-12 border-t border-hairline pt-12">
          <div className="md:col-span-5">
            <p className="text-sm tracking-[0.15em] uppercase text-mist mb-4">E-posta</p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              data-testid="contact-email"
              className="group inline-flex items-center gap-2 font-semibold text-xl md:text-2xl text-sand hover:text-gold transition-colors break-all"
            >
              {CONTACT_EMAIL}
              <ArrowUpRight size={22} className="shrink-0 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
            <p className="mt-6 text-sm font-light text-mist max-w-sm">
              İş birliği, danışmanlık ve proje talepleriniz için e-posta yoluyla ulaşabilirsiniz.
            </p>

            {/* Sosyal Medya */}
            <div className="mt-8">
              <p className="text-sm tracking-[0.15em] uppercase text-mist mb-3">Sosyal Medya</p>
              <div className="flex flex-wrap gap-3">
                {SOCIAL_LINKS.map((s) => {
                  const Icon = SOCIAL_ICONS[s.icon] || ArrowUpRight;
                  return (
                    <a
                      key={s.label}
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`social-${s.icon}`}
                      className="group inline-flex items-center gap-2 px-4 py-2.5 border border-hairline rounded-full hover:border-gold/60 hover:bg-gold/5 transition-colors"
                    >
                      <Icon size={18} className="text-gold" />
                      <div className="flex flex-col items-start leading-tight">
                        <span className="text-[10px] tracking-[0.2em] uppercase text-mist">{s.label}</span>
                        <span className="text-sm text-sand group-hover:text-gold transition-colors">{s.handle}</span>
                      </div>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="text-sm tracking-[0.15em] uppercase text-mist mb-4">Bölümler</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sand/80 hover:text-gold transition-colors">{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm tracking-[0.15em] uppercase text-mist mb-4">Bağlantılar</p>
            <ul className="space-y-3">
              {QUICK_LINKS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    data-testid={`quick-link-${s.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sand/80 hover:text-gold transition-colors"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-20 mb-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-mist">
          <span className="text-sm font-semibold text-sand">{BRAND}</span>
          <span>© {new Date().getFullYear()} {BRAND}</span>
          <span className="tracking-[0.15em] uppercase">{BRAND_SUB}</span>
        </div>
      </div>

      <motion.div
        aria-hidden
        className="pointer-events-none absolute -bottom-1/3 left-1/2 -translate-x-1/2 w-[80vw] h-[40vw] rounded-full"
        style={{ background: "radial-gradient(closest-side, rgba(224,169,46,0.10), transparent)" }}
      />
    </footer>
  );
};
